export const year2017 = [
  { year: '2017 and earlier' },
  {
    author: 'Various authors',
    name: 'Hack Design',
    link: 'https://hackdesign.org/',
    type: 'Course',
  },
  {
    author: 'FreeCodeCamp',
    name: 'Basic JavaScript',
    link:
      'https://learn.freecodecamp.org/javascript-algorithms-and-data-structures/basic-javascript',
    type: 'Course',
  },
  {
    author: 'Codecademy',
    name: 'React Part 1 & 2, JavaScript, Responsive Design, HTML, CSS, Git',
    link: 'https://www.codecademy.com/catalog/subject/all',
    type: 'Course',
  },
];
